import { LinkingOptions } from "@react-navigation/native";

export const linking = {
  prefixes: ['http://localhost:8080', 'https://deante.pro'],
  config: {
    screens: {
      // This will map to the Home screen when accessing the root URL.



      Home: '',

      Unit: {

        path: ':idUnit',
        parse: {
          idUnit: (idUnit: string) => {
            const parsedId = parseInt(idUnit, 10);
            return isNaN(parsedId) ? null : parsedId; // Фильтруем нечисловые значения
          },
        },
        stringify: {
          idUnit: (idUnit: number) => idUnit.toString(),
        },
      },

      Collection: {
        path: 'collection',
        parse: {
          collection_name: (name) => {
            console.log('🔥 Decoded Collection Name:', decodeURIComponent(name));
            return decodeURIComponent(name);
          },
        },
        stringify: {
          collection_name: (name) => encodeURIComponent(name),
        },
      },

      Account: {
        path: 'account'
      },

      Catalogs: {
        path: 'catalogs'
      },

       InstructionsBuild: {
        path: 'instructions-build'
      },

      ServiceCenter: {
        path: 'service-center'
      },

      LicensesAndCertificates: {
         path: 'licenses-and-certificates'
      },


      SearchPage: {
        path: 'search',
        parse: {
          query: (name) => {
            console.log('🔥 Decoded query ', decodeURIComponent(name));
            return decodeURIComponent(name);
          },
        },
        stringify: {
          query: (name) => encodeURIComponent(name),
        },
      },


      Collections: {
        path: 'collections',

      },
      Catalog: {
  path: 'catalog',
  parse: {
    type: (value: string) => value, // НИЧЕГО не декодим
    subTypes: (value: string) =>
      value
        .split(',')
        .map((v) => v.trim())
        .filter(Boolean),
    colors: (value: string) =>
      value
        .split(',')
        .map((v) => v.trim())
        .filter(Boolean),
  },
  stringify: {
    type: (value?: string) => (value ? value : ''),
    subTypes: (value?: string[] | string) => {
      if (!value) return '';
      const arr = Array.isArray(value) ? value : [value];
      return arr.join(',');
    },
    colors: (value?: string[] | string) => {
      if (!value) return '';
      const arr = Array.isArray(value) ? value : [value];
      return arr.join(',');
    },
  },
},

      Cart: {
        path: 'cart',
        parse: {
          history: (value: string) => value === '1' || value === 'true',
          orderId: (value: string) => decodeURIComponent(value),
        },
        stringify: {
          history: (value?: boolean) => (value ? '1' : undefined),
          orderId: (value?: string) => (value ? encodeURIComponent(value) : undefined),
        },
      },




      // Portfolio: {
      //   path: 'portfolio',
      //   parse: {
      //     id: (name) => {
      //       console.log('🔥 Decoded ID Name-:', decodeURIComponent(name));
      //       return decodeURIComponent(name);
      //     },
      //   },
      //   stringify: {
      //     id: (name) => encodeURIComponent(name),
      //   },
      // },
      WhereToBuy: {
        path: 'puchase-info'
      },

      About: 'about',

      Contacts: 'contacts'
    },
  },
  // 👇 This disables auto title updates from linking
  getInitialURL: async () => window.location.href,
  getStateFromPath: (path, config) =>
    require('@react-navigation/native').getStateFromPath(path, config),
  getPathFromState: (state, config) =>
    require('@react-navigation/native').getPathFromState(state, config),
  // 👇 This is what stops document.title from changing

} as LinkingOptions<any>;
